import React from "react"
import Tabs, { type TabItem } from "@/components/terra/component/Tabs/Tabs"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { createRichTextOptions } from "@/lib/formatters/formatRichText"
import { DEFAULT_PUBLIC_LANG } from "@/lib/locale/toContentfulLocale"

function renderTabContent(
  content: any,
  lang: string = DEFAULT_PUBLIC_LANG,
): React.ReactNode {
  if (!content) return null

  if (content.__typename === "RichTextContent" && content.content?.json) {
    return (
      <div className="richtxt">
        {documentToReactComponents(
          content.content.json,
          createRichTextOptions(lang),
        )}
      </div>
    )
  }

  return null
}

export default function MXPFormatTabs(props: any) {
  const { value, lang = DEFAULT_PUBLIC_LANG } = props

  const tabItems = value.tabsCollection?.items || []

  const tabs: TabItem[] = tabItems
    .filter((tab: any) => tab != null)
    .map((tab: any) => ({
      header: tab.header || tab.title || "",
      description: tab.description || undefined,
      image: tab.image
        ? {
            url: tab.image.image?.url,
            alt: tab.image.altText || tab.image.title || "",
          }
        : undefined,
      content: renderTabContent(tab.content, lang),
      contentfulId: tab.sys?.id || undefined,
    }))

  const orientationMap: Record<string, string> = {
    Top: "top",
    Bottom: "bottom",
    Left: "left",
    Right: "right",
    top: "top",
    bottom: "bottom",
    left: "left",
    right: "right",
  }

  const orientation = orientationMap[value.tabOrientation] || "top"

  return (
    <Tabs
      tabs={tabs}
      orientation={orientation}
      variant={value.variant}
      displayThumbnails={value.displayThumbnails ?? false}
      contentfulId={value.sys?.id || undefined}
    />
  )
}
